module.exports = __webpack_public_path__ + "img/pic8.5e49e560.png";